"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditFacilityConfigWithSlugSchema = exports.CashBalanceFeed = exports.FinancialStatementLocalizationConfigSchema = exports.FinancialDisplayFormatSchema = exports.LocalizationConfigSchema = exports.LocalizationScopeSchema = exports.BorrowerConfigSchema = exports.USER_ROLE_TYPES = exports.BaseOrganizationSchema = exports.OrganizationType = exports.CreditFacilitySourceConfigSchema = exports.FundingRequestDocxGenerationConfigSchema = exports.DocxDocumentGenerationConfigSchema = exports.ReceivablesSaleAgreementGenerationConfigSchema = void 0;
const Email_1 = require("./Email");
const Bank_1 = require("./Bank");
const Email_2 = require("./Email");
const FundingRequest_1 = require("./FundingRequest");
const Report_1 = require("./Report");
const v4_1 = require("zod/v4");
exports.ReceivablesSaleAgreementGenerationConfigSchema = v4_1.z.object({
    receivablesSaleAgreement: v4_1.z.boolean(),
});
exports.DocxDocumentGenerationConfigSchema = v4_1.z.object({
    fundingComponentTypes: FundingRequest_1.FundingRequestComponentTypeSchema.array().describe('Funding component types to be included in the document generation.'),
});
// FundingRequestDocxGenerationConfig is a record of ReportType to DocxDocumentGenerationConfig
exports.FundingRequestDocxGenerationConfigSchema = v4_1.z.partialRecord(Report_1.ReportTypeSchema, exports.DocxDocumentGenerationConfigSchema);
exports.CreditFacilitySourceConfigSchema = v4_1.z.object({
    isEnabledForStreaming: v4_1.z
        .boolean()
        .optional()
        .describe('Set this to true if borrower is enabled for streaming.'),
    digestEmailDeliveryCadence: v4_1.z
        .array(Email_2.DeliveryCadenceSchema)
        .describe('Decides the cadence of digest email delivery.'), // Could use DeliveryCadenceSchema if available
    isEnabledForBorrowingBaseReserve: v4_1.z
        .boolean()
        .describe('Set this to true if borrower is enabled for borrowing base reserve.'),
    isBorrowingBaseReservePositiveExcessCollectionsOverReserve: v4_1.z
        .boolean()
        .describe('Decides if the borrower is borrowing base reserve positive excess collections over reserve.'),
    receivablesSaleAgreementGenerationConfig: exports.ReceivablesSaleAgreementGenerationConfigSchema.describe('Configuration for receivables sale agreement generation.'),
    fundingRequestDocxGenerationConfig: exports.FundingRequestDocxGenerationConfigSchema.optional().describe('Configuration for funding request docx generation.'),
    cashBalancesFeedMethodPointer: v4_1.z
        .string()
        .nullable()
        .describe('Cash balance conversion pointer.'),
    f1FormulaEngine: v4_1.z
        .enum(['compareOnly', 'use'])
        .optional()
        .describe('Temporary optional flag for formula engine evaluation use'),
});
// many of types will eventually be removed, as these are defined within
// context of CA
var OrganizationType;
(function (OrganizationType) {
    OrganizationType["AdminAgent"] = "adminAgent";
    OrganizationType["BackupServicer"] = "backupServicer";
    OrganizationType["Borrower"] = "borrower";
    OrganizationType["CapitalProvider"] = "capitalProvider";
    OrganizationType["CapitalProviderRepresentative"] = "capitalProviderRepresentative";
    OrganizationType["CollectionAccountBank"] = "collectionAccountBank";
    OrganizationType["PayingAgent"] = "payingAgent";
    OrganizationType["Servicer"] = "servicer";
    OrganizationType["Special"] = "special";
    OrganizationType["VerificationAgent"] = "verificationAgent";
})(OrganizationType || (exports.OrganizationType = OrganizationType = {}));
/**
 * Minimal set of organization properties that are exposed to other
 * organizations on an allowlist basis.
 */
exports.BaseOrganizationSchema = v4_1.z.object({
    id: v4_1.z.string(),
    name: v4_1.z.string(),
    slug: v4_1.z.string(),
});
exports.USER_ROLE_TYPES = [
    'ADMIN',
    'MEMBER',
    'CONTRIBUTOR',
];
exports.BorrowerConfigSchema = v4_1.z.object({
    isEnabledForStreaming: v4_1.z
        .boolean()
        .optional()
        .describe('Set this to true if borrower is enabled for streaming.'),
    internalSlack: v4_1.z
        .object({
        channel: v4_1.z.string(),
        webhookUri: v4_1.z.string(),
    })
        .nullable()
        .describe('Internal slack notification config'),
    cashBalancePreference: Bank_1.CashBalanceTypeSchema,
    slug: v4_1.z.string(),
    digestEmailSections: v4_1.z.array(Email_1.DigestEmailSectionSchema),
});
/**
 * Localization configuration for custom label mappings per organization
 * Allows organizations to customize the display labels used in their UI
 */
exports.LocalizationScopeSchema = v4_1.z.enum(['borrowingBaseSummary']);
exports.LocalizationConfigSchema = v4_1.z.object({
    labelMappings: v4_1.z
        .record(exports.LocalizationScopeSchema, v4_1.z.record(v4_1.z.string().describe('Default label key'), v4_1.z.string().describe('Localized/customized label value')))
        .describe('Mapping of scopes to label key-value pairs for customization'),
});
/**
 * Financial display format options
 */
exports.FinancialDisplayFormatSchema = v4_1.z.enum(['K', 'M', 'B', 'full']).describe('Format for displaying financial values: K (thousands), M (millions), B (billions), or full');
/**
 * Financial statement formatting configuration
 * Allows organizations to customize how financial values are displayed
 */
exports.FinancialStatementLocalizationConfigSchema = v4_1.z.object({
    financialFormatting: v4_1.z.object({
        displayFormat: exports.FinancialDisplayFormatSchema,
    }).describe('Configuration for financial statement value formatting'),
});
var CashBalanceFeed;
(function (CashBalanceFeed) {
    [];
})(CashBalanceFeed || (exports.CashBalanceFeed = CashBalanceFeed = {}));
exports.CreditFacilityConfigWithSlugSchema = exports.CreditFacilitySourceConfigSchema.extend({
    creditFacilitySlug: v4_1.z.string(),
});
//# sourceMappingURL=Organization.js.map